import React, { useEffect } from "react";
import { useAuthStore } from "./authStore";

type TContext = {
  isLogin: boolean;
  toggleLogin: () => void;
};

const LoginContext = React.createContext<TContext>({
  isLogin: false,
  toggleLogin: () => {},
});

export const LoginContextProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const { isAuthenticated, logout } = useAuthStore();

  function toggleLogin() {
    if (isAuthenticated) {
      logout(); // Use proper logout if authenticated
    }
  }

  const loginValue: TContext = {
    isLogin: isAuthenticated, // Sync with new auth store
    toggleLogin: toggleLogin,
  };

  return (
    <LoginContext.Provider value={loginValue}>
      {props.children}
    </LoginContext.Provider>
  );
};

export default LoginContext;
